import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services';

export const authTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const shouldAttachToken = environment.authConfig.secureRoutes.some((route) => request.url.startsWith(route));

  if (!shouldAttachToken) {
    return next(request);
  }

  return from(authService.getAccessToken()).pipe(
    switchMap((accessToken) => {
      if (!accessToken) {
        return next(request);
      }

      return next(request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      }));
    })
  );
};
